export function getDisplayDate(date: Date) {
    const newDate = new Date(date);

    return newDate.toLocaleDateString('nl-NL');
}
